import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rl-page-not-found',
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {}
